/**
 * @generated SignedSource<<9e7f378dbfca998cbf7750ca62f77975>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CityWalkComplete_cityWalk",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    }
  ],
  "type": "CityWalk",
  "abstractKey": null
};

node.hash = "7a2768ae61cd6beba897a3dae9c0e224";

module.exports = node;
